import { render, staticRenderFns } from "./PostulantPaymentCellComponent.vue?vue&type=template&id=79b7a42c&scoped=true&"
import script from "./PostulantPaymentCellComponent.vue?vue&type=script&lang=js&"
export * from "./PostulantPaymentCellComponent.vue?vue&type=script&lang=js&"
import style0 from "./PostulantPaymentCellComponent.vue?vue&type=style&index=0&id=79b7a42c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b7a42c",
  null
  
)

export default component.exports